import React from 'react';
const GetInTouchForm = React.lazy(() => import('./GetInTouch'));
const SubscriptionForm = React.lazy(() => import('./Subscription'));

export { GetInTouchForm, SubscriptionForm };
